import {styled} from "@mui/material/styles";
import { Chip, FormControl, TextField } from "@mui/material";
import { BaseAutocomplete, BaseTextField, MediaQuerys } from "../../styles/GlobalStyle";
import { useColors } from "../../Context/ColorsContext";
const { mobile, tablet, desktop } = MediaQuerys;

export const CustomFormControl = styled(FormControl)(() => ({
    maxWidth: '100%',
    '& .Mui-disabled': {
        backgroundColor: '#fbfcfd'
    }
}));

export const CustomAutocomplete = styled(BaseAutocomplete)(() => ({
}))

export const Input = styled(BaseTextField)(({ theme, limitTags }) => {
  return {
    '& .MuiInputBase-root': {
			paddingTop: '4px !important',
			paddingBottom: '4px !important',
      borderRadius: '8px',
      border: 'none',
      height: (limitTags === 1) ? '32px' : 'auto',
      minHeight: '32px',
      alignItems: 'center',
      flexWrap: (limitTags === 1) ? 'nowrap' : 'wrap',
      overflow: (limitTags === 1) ? 'hidden' : 'visible',
      backgroundColor: '#fff',
      '&.Mui-disabled': {
        backgroundColor: '#fbfcfd',
      }
    },
    '& .MuiInputBase-input': {
      height: (limitTags === 1) ? '20px !important' : 'auto !important',
      padding: '0 14px !important',
      boxSizing: 'border-box',
      fontSize: '14px',
      lineHeight: (limitTags === 1) ? '20px !important' : 'inherit',
      borderRadius: '8px',
    },
    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#dbdcdcff',
        borderWidth: '1px',
        borderStyle: 'solid',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#c0c1c3ff',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#babbc0',
        borderWidth: '1px',
      },
      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: '#eeeeef',
      }
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiInputBase-input': {
        fontSize: '12px',
      },
    }
  }
})

export const CustomChip = styled(Chip)(({isInvalid, isSpecial, isError}) => {
	const { colors } = useColors();
  	return {
		// Modificar color de chip si es válido o no, en caso contrario dejar color original
		// background: isValid === true ? colors.green : isValid === false ? colors.darkOrange : '#e1ecf7',
		background: isInvalid === true ? "#FFE08A" : (isError ? "#ffe3e3" : (isSpecial ? "#cefadc" : "#e1ecf7")),
		// Modificar color de icono de cerrar dependiendo de si es válido o no
		'.MuiSvgIcon-root': {
			fontSize: 14,
			color: isInvalid === true || isInvalid === false ? '#565657ff' : '#29476d',
            marginLeft: 1,
		},
		'.MuiChip-label': {
			paddingLeft: 9,
			paddingRight: 9,
			fontWeight: 'bold',
			color: isInvalid === true || isInvalid === false ? '#464646ff' : colors.buttonActionColor,
		},
        // color: isValid === true || isValid === false ? '#565657ff' : '#29476d',
        color: isInvalid == true || isSpecial == true || isError == true ? "#565657ff" : "#29476d",
        borderRadius: 8,
        fontWeight: 'bold',
        fontSize: '14px',
		[tablet]: {
			fontSize: '12px',
		},
	}
})
